import { point } from "leaflet";
import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { AssessmentsController } from "../scripts/assessments.controller";
import { AssessmentsDialog } from "../scripts/assessments.dialog";
import { Assessment, AssessmentEvent } from "../scripts/assessments.entities";
import { AssessmentLookup } from "../scripts/assessments.lookup";
import { AssessmentSummarySeries } from "./assessments-summary.entities";
import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";
import { Visit } from "../../visits-tab/scripts/visits.entities";

var Highcharts = require('highcharts/highcharts');



export class AssessmentsSummaryView {

    visitSummaryChart: any;
    siteSummaryChart: any;
    visitCompletionChart: any;
    siteCompletionChart: any;
    selectedGrouping: string; //visit, site
    selectedData: string; //summary, completion
    drillBackUpAssessmentData: any = null; // chart data for drilling back up
    drillBackUpVisitData: any = null;
    assessmentStatusData: Set<string> = new Set();

    constructor() {
        this.selectedGrouping = "assessment";
        this.selectedData = "status";
        // console.log('AssessmentsSummaryView initialized:', { selectedGrouping: this.selectedGrouping, selectedData: this.selectedData });
    }

    UpdateData(visitSeries: AssessmentSummarySeries[], siteSeries: AssessmentSummarySeries[], assessmentSeries: AssessmentSummarySeries[]): void {
        // console.log('UpdateData called:', { visitSeries, siteSeries });

        console.log(visitSeries);
        //console.log(assessmentSeries);

        this.updateChart('assessment-byvisit-summary-status-chart', visitSeries, [1, 6, 3, 2, 5], "Timepoints");
        this.updateChart('assessment-bysite-summary-status-chart', siteSeries, [1, 6, 3, 2, 5], "Sites");
        this.updateChart('assessment-byassessment-summary-status-chart', assessmentSeries, [1, 6, 3, 2, 5], "Assessments");


        this.updateChart('assessment-byvisit-summary-completion-chart', visitSeries, [20, 21, 22, 23, 24], "Timepoints");
        this.updateChart('assessment-bysite-summary-completion-chart', siteSeries, [20, 21, 22, 23, 24], "Sites");
        this.updateChart('assessment-byassessment-summary-completion-chart', assessmentSeries, [20, 21, 22, 23, 24], "Assessments");
   
    }


    private updateChart(chartId: string, data: AssessmentSummarySeries[], visitStatusIds: number[], axisLabel: string): void {
        // console.log('updateChart called:', { chartId, data, visitStatusIds, axisLabel });
        
        let series: any[] = [];
        let categories: string[] = [];
        let visits: AssessmentEvent[] = [];
       visitStatusIds.forEach((statusId: number) => {

            let seriesData: any[] = new Array<any>(data.length).fill(0);
            //let seriesData: number[] = new Array<number>(data.length).fill(0);
            //let visitsData: any[] = [];
            for (let i = 0; i < data.length; ++i) {

                if (!categories.includes(data[i].name)) { categories.push(data[i].name); }
                //if (data[i].data.has(statusId)) {
                //    seriesData[i] = data[i].data.get(statusId);
                //    visits.push(...data[i].visits);
                //}
                if (data[i].visits.has(statusId)) {
                    seriesData[i] = { y: data[i].visits.get(statusId).length, visits: data[i].visits.get(statusId) };
                    //seriesData[i] = data[i].visits.get(statusId).length;
                    //visitsData[i] = data[i].visits.get(statusId);
                }
            }

            series.push({
                name: AssessmentLookup.GetStatusColumn(statusId), // Changed from GetVisitStatus to GetStatusColumn
                data: seriesData,
                colorIndex: AssessmentLookup.GetAssessmentStatusColorIndex(statusId)
            });
       });      
        
        // console.log('Chart series data:', series);
        this.initializeBarChart(chartId, axisLabel, categories, series);
    }

    private initializeBarChart(chartId: string, axisLabel: string, categories: string[], data: any[]): any {
        // console.log('initializeBarChart called:', { chartId, axisLabel, categories, data });

        //console.log(chartId, axisLabel, categories, data);
        //console.log(categories.length, (40 * categories.length));
        //console.log(data);
        if (chartId === 'assessment-byassessment-summary-status-chart') {
            this.drillBackUpAssessmentData = { chartId, axisLabel, categories, data };
        } else if (chartId === 'assessment-byvisit-summary-status-chart') {
            this.drillBackUpVisitData = { chartId, axisLabel, categories, data };
        }     

       
        //console.log(this.drillBackUpVisitData);      
        const self = this;
        let chart: any = Highcharts.chart(chartId, {
            chart: {
                type: 'bar',
                styledMode: true,
                height: 100 + (45 * categories.length)
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                categories: categories,
                min: 0,
                max: categories.length - 1,
                title: { text: axisLabel },
                tickInterval: 1,
                tickLength: 0,
                labels: {
                    align: 'right',
                    useHTML: true,
                    formatter: function () {
                        if (chartId === 'assessment-byassessment-summary-status-chart' || chartId === 'assessment-byvisit-summary-status-chart') {
                            return `<span class="category-label drilldown-label" data-category="${this.value}" data-chartid="${chartId}">${this.value}</span>`;
                        } else {
                            return this.value; 
                        }
                    }
                }
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                reversedStacks: false,
                title: { text: 'Timepoint Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    },
                    inside: false, //label issues
                    verticalAlign: 'middle',
                }
            },
            legend: {
                //    enabled: false,
                //    reversed: false,
                //    title: {
                //        text: '<div style="font-size: 10px; color: #666; font-weight: normal; width: 100%; text-align: center">Visits</span>',
                //    },
                align: 'center',
                verticalAlign: 'top',
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    point: {
                        events: {
                            click: function () {                             
                                AssessmentsDialog.ShowDialog(this.options.visits);                              
                            }
                        }
                    },
                },
                bar: {
                    pointWidth: 25,
                    pointPadding: 0.1,
                    //groupPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            if (this.y == 0) return null;
                            else {
                                let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                else return label;
                            }
                        },
                        verticalAlign: 'middle',
                        y: 2
                    },
                },
            },
            series: data,
        });   
        document.querySelectorAll('.drilldown-label').forEach((label) => {
            label.addEventListener('click', function (event) {
                event.stopPropagation();
                const categoryName = (event.target as HTMLElement).dataset.category;
                const categoryIndex = categories.indexOf(categoryName);

                if (categoryIndex === -1) {
                    console.warn(`${categoryName} not found`);
                    return;
                }


                const seriesData = chart.series.map(series => ({
                    name: series.name,
                    data: series.data[categoryIndex].options
                }));

                self.updateChartForDrilldown(seriesData, chartId, categoryName);
            });
        });

        // console.log('Chart initialized:', chart);
        return chart;
    }


    

    SetView(newView: string): void {
        // console.log('SetView called:', { newView });

        if (!newView.startsWith("assessment-summary")) { return; }
        else if (newView != "assessment-summary") { //new within-summary view
            if (newView.includes("byvisit")) { this.selectedGrouping = "visit"; }
            else if (newView.includes("bysite")) { this.selectedGrouping = "site"; }
            else if (newView.includes("byassessment")) { this.selectedGrouping = "assessment"; }

            if (newView.includes("bystatus")) { this.selectedData = "status"; }
            else if (newView.includes("bycompletion")) { this.selectedData = "completion"; }
        }

        if (this.selectedGrouping == "visit" && this.selectedData == "status") { SetActiveTab("assessment-summary-tabs", "content-summary-assessment-byvisit-status"); }
        else if (this.selectedGrouping == "site" && this.selectedData == "status") { SetActiveTab("assessment-summary-tabs", "content-summary-assessment-bysite-status"); }
        else if (this.selectedGrouping == "assessment" && this.selectedData == "status") { SetActiveTab("assessment-summary-tabs", "content-summary-assessment-byassessment-status"); }
        else if (this.selectedGrouping == "visit" && this.selectedData == "completion") { SetActiveTab("assessment-summary-tabs", "content-summary-assessment-byvisit-completion"); }
        else if (this.selectedGrouping == "site" && this.selectedData == "completion") { SetActiveTab("assessment-summary-tabs", "content-summary-assessment-bysite-completion"); }
        else if (this.selectedGrouping == "assessment" && this.selectedData == "completion") { SetActiveTab("assessment-summary-tabs", "content-summary-assessment-byassessment-completion"); }

        // console.log('View updated:', { selectedGrouping: this.selectedGrouping, selectedData: this.selectedData });
    }



    private updateChartForDrilldown(data, chartId: string, nameOfItem): void {
        let drilldownData: Map<number, Map<number, { count: number, visits: any[] }>> = new Map();
        console.log("current drill data", data);
        const self = this;       

        if (chartId === 'assessment-byassessment-summary-status-chart') {
            data.forEach((series) => {
                if (!series.data || !series.data.visits || series.data.visits.length === 0) {
                    return;
                }
                const visits = series.data.visits;

                visits.forEach((event: any) => {
                    if (!drilldownData.has(event.TimepointId)) {
                        drilldownData.set(event.TimepointId, new Map());
                    }

                    let statusMap = drilldownData.get(event.TimepointId)!;

                    if (!statusMap.has(event.StatusId)) {
                        statusMap.set(event.StatusId, { count: 0, visits: [] });
                    }

                    const statusEntry = statusMap.get(event.StatusId)!;
                    statusEntry.count += 1;
                    statusEntry.visits.push(event);
                });
            });

            const orderedTimepoints = Array.from(drilldownData.keys())
                .sort((a, b) => VisitLookup.GetVisitMasterOrdering(a) - VisitLookup.GetVisitMasterOrdering(b));

            let categories: string[] = [];
            let seriesMap: Map<number, { name: string; data: { y: number, visits: any[] }[], colorIndex: number }> = new Map();


            drilldownData.forEach((statusCounts) => {
                statusCounts.forEach((_, statusId) => {
                    if (!seriesMap.has(statusId)) {
                        const statusName = AssessmentLookup.GetStatusColumn(statusId);
                        const colorIndex = AssessmentLookup.GetAssessmentStatusColorIndex(statusId);
                        seriesMap.set(statusId, { name: statusName, data: [], colorIndex: colorIndex, });                      
                    }
                });
            });


            //drilldownData.forEach((statusCounts, timepointId) => {
            //    const timepointName = AssessmentLookup.GetTimepointColumn(timepointId);
            //    categories.push(`${timepointName}`);


            //    seriesMap.forEach((series, statusId) => {
            //        series.data.push(statusCounts.get(statusId) || 0,);
            //    });
            //});

            orderedTimepoints.forEach((timepointId) => {
                const timepointName = VisitLookup.GetVisitMasterColumn(timepointId);
                categories.push(timepointName);

                const statusMap = drilldownData.get(timepointId) || new Map();

                seriesMap.forEach((series, statusId) => {
                    const entry = statusMap.get(statusId);
                    series.data.push({
                        y: entry ? entry.count : 0,
                        visits: entry ? entry.visits : []
                    });
                });
            });       

            const series = Array.from(seriesMap.values()).reverse();
            console.log('Drill', drilldownData);
            Highcharts.chart('assessment-byassessment-summary-status-chart', {
                chart: {
                    type: 'bar',
                    styledMode: true,
                    height: 200 + (45 * categories.length),
                    events: {
                        load: function () {
                            $('#assessment-byassessment-summary-status-chart').prepend(
                                `<div class="chart-header">
                                <button class='btn btn-outline-secondary chart-drillup-btn mr-2 ml-2'><i class="fas fa-undo"></i></button>
                                <span class="drilldown-title">Timepoints for ${nameOfItem}</span>
                                </div>`
                            );
                            $('#assessment-byassessment-summary-status-chart').find(".chart-drillup-btn").on('click', () => {
                                self.restoreOriginalChart(self.drillBackUpAssessmentData);
                            });
                        }
                    },
                },
                title: { text: null },
                credits: { enabled: false },
                xAxis: {
                    categories: categories,
                    title: {
                        text: 'Timepoints'
                    },                   
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Count'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: 'gray'
                        },
                        formatter: function () {
                            return this.total; 
                        }
                    }
                },
                legend: {
                    align: 'center',
                    verticalAlign: 'top',
                    reversed: true,
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        },
                        point: {
                            events: {
                                 click: function () {
                                    AssessmentsDialog.ShowDialog(this.options.visits);
                                }
                            }
                        },
                    },
                    bar: {
                        pointWidth: 25,
                        pointPadding: 0.1,
                        //groupPadding: 0.2,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                if (this.y == 0) return null;
                                else {
                                    let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                    if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                    else return label;
                                }
                            },
                            verticalAlign: 'middle',
                            y: 2
                        },
                    },
                },
                series: series,

            });
        }
       else if (chartId == 'assessment-byvisit-summary-status-chart') {
            data.forEach((series) => {
                if (!series.data || !series.data.visits || series.data.visits.length === 0) {
                    return;
                }
                const visits = series.data.visits;

                visits.forEach((event: any) => {
                    if (!drilldownData.has(event.NameId)) {
                        drilldownData.set(event.NameId, new Map());
                    }

                    let statusMap = drilldownData.get(event.NameId)!;

                    if (!statusMap.has(event.StatusId)) {
                        statusMap.set(event.StatusId, { count: 0, visits: [] });
                    }

                    const statusEntry = statusMap.get(event.StatusId)!;
                    statusEntry.count += 1;
                    statusEntry.visits.push(event);
                });
            });


            const orderedAssessments = Array.from(drilldownData.keys())
                .sort((a, b) => AssessmentLookup.GetAssessmentOrdering(a) - AssessmentLookup.GetAssessmentOrdering(b));

            let categories: string[] = [];
            let seriesMap: Map<number, { name: string; data: { y: number, visits: any[] }[], colorIndex: number }> = new Map();


            drilldownData.forEach((statusCounts) => {
                statusCounts.forEach((_, statusId) => {
                    if (!seriesMap.has(statusId)) {
                        const statusName = AssessmentLookup.GetStatusColumn(statusId);
                        const colorIndex = AssessmentLookup.GetAssessmentStatusColorIndex(statusId);
                        seriesMap.set(statusId, { name: statusName, data: [], colorIndex: colorIndex, });
                    }
                });
            });


            //drilldownData.forEach((statusCounts, assessmentId) => {
            //    const assessmentName = AssessmentLookup.GetNameColumn(assessmentId);
            //    categories.push(`${assessmentName}`);

            //    seriesMap.forEach((series, statusId) => {
            //        series.data.push(statusCounts.get(statusId) || 0,);

            //    });
            //});
           

            orderedAssessments.forEach((nameId) => {
                const assessmentName = AssessmentLookup.GetNameColumn(nameId);
                categories.push(assessmentName);

                const statusMap = drilldownData.get(nameId) || new Map();

                seriesMap.forEach((series, statusId) => {
                    const entry = statusMap.get(statusId);
                    series.data.push({
                        y: entry ? entry.count : 0,
                        visits: entry ? entry.visits : []
                    });
                });
            });

            const series = Array.from(seriesMap.values()).reverse();
            console.log('Drill', drilldownData);
            Highcharts.chart('assessment-byvisit-summary-status-chart', {
                chart: {
                    type: 'bar',
                    styledMode: true,
                    height: 200 + (45 * categories.length),
                    events: {
                        load: function () {
                            $('#assessment-byvisit-summary-status-chart').prepend(
                                `<div class="chart-header">
                                <button class='btn btn-outline-secondary chart-drillup-btn mr-2 ml-2'><i class="fas fa-undo"></i></button>
                                <span class="drilldown-title">Assessments for ${nameOfItem}</span>
                                </div>`
                            );
                            $('#assessment-byvisit-summary-status-chart').find(".chart-drillup-btn").on('click', () => {
                                self.restoreOriginalChart(self.drillBackUpVisitData);
                            });
                        }
                    },
                },
                title: { text: null },
                credits: { enabled: false },
                xAxis: {
                    categories: categories,
                    title: {
                        text: 'Assessments'
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Count'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: 'gray'
                        },
                        formatter: function () {
                            return this.total; 
                        }
                    }
                },
                legend: {
                    align: 'center',
                    verticalAlign: 'top',
                    reversed: true,
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        },
                        point: {
                            events: {
                                click: function () {
                                    AssessmentsDialog.ShowDialog(this.options.visits);
                                }
                            }
                        },
                    },
                    bar: {
                        ointWidth: 25,
                        pointPadding: 0.1,
                        //groupPadding: 0.2,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                if (this.y == 0) return null;
                                else {
                                    let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                    if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                    else return label;
                                }
                            },
                            verticalAlign: 'middle',
                            y: 2
                        },
                    },
                },
                series: series,
            });

        }

    }

    private restoreOriginalChart(chartData: { chartId: string, axisLabel: string, categories: string[], data: any[] }): void {
        const chartContainer = Highcharts.charts.find(chart => chart?.renderTo.id === chartData.chartId);


        if (chartContainer) {
            chartContainer.destroy();
        }


        if (chartData) {
            setTimeout(() => {
                this.initializeBarChart(
                    chartData.chartId,
                    chartData.axisLabel,
                    chartData.categories,
                    chartData.data
                );
            }, 50);
        }
    }
}